import { Container } from '@mui/material';
import useExplorePageStyles from '../useExplorePageStyles';

/**
 * HorizontalPad component renders a horizontal bar to serve as dynamic padding in a flex grid.
 */
const HorizontalPad = () => {
  const { classes } = useExplorePageStyles();
  return (
    <div>
      <Container className={classes.horizontalPad} disableGutters></Container>
    </div>
  );
};

export default HorizontalPad;
